import classNames from 'classnames';
import styles from './notification-dot.scss';
import React from 'react';

export const NotificationDot: React.FC<{
  hideLg?: boolean;
  inline?: boolean;
}> = ({ hideLg, inline }) => {
  return (
    <div
      className={classNames(styles.dot, {
        [styles.hideLg]: hideLg,
        [styles.inline]: inline,
      })}
    />
  );
};
